import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { API_URL } from '../../../constants/baseUrlApiStatic'
import { District } from '../../../interfaces/district'
import { DataRTKReturn, DataRTKReturnList } from '../../../interfaces/dataRTKReturn'
import { IProductSearchedViewed, IProductSearchedViewedUpdt } from '../../../interfaces/productSearchedViewed'
import { IBuilderSearch } from '../../../interfaces/builderSearch'
import { IFair } from '../../../interfaces/fair/fair'
import { IPromotion } from '../../../interfaces/promotion'
import { IAddressZipcode } from '../../../interfaces/addressZipcode'
import { IContactNewsletter } from '../../../interfaces/contact'
import { ICardBlog, ICategoryBlog, ICommentBlog } from '../../../interfaces/blog'
import {INotification, IReqNotification, IToggleNotification} from '../../../interfaces/notifications'
import { CardWorkUs, FormCandidate } from '../../../interfaces/workUs'

const generalApi = createApi({
  reducerPath: 'generalApi',
  baseQuery: fetchBaseQuery({ baseUrl: `${API_URL}` }),
  tagTypes: ['generals'],
  endpoints: (builder) => ({
    addProductSearchedViewed: builder.mutation<DataRTKReturn<string>, IProductSearchedViewed>({
      query: (content) => ({
        url: `/product-searched-viewed/add`,
        body: JSON.stringify(content),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      }),
      invalidatesTags: ['generals']
    }),
    getProductSearchedViewed: builder.query<DataRTKReturn<string>, string>({
      query: (id) => `/product-searched-viewed/get-by-id/${id}`
    }),
    getProductsByBuilderId: builder.query<DataRTKReturnList<IBuilderSearch>, string>({
      query: (id) => `/glemo/construction-company-by-argument?argument=${id}`
    }),
    updtProductSearchedViewed: builder.mutation<string, IProductSearchedViewedUpdt>({
      query: (content) => ({
        url: `/product-searched-viewed/update`,
        body: JSON.stringify(content),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      }),
      invalidatesTags: ['generals']
    }),
    createContactNewsletter: builder.mutation<string, IContactNewsletter>({
      query: (content) => ({
        url: `/news/create-contact`,
        body: JSON.stringify(content),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      }),
      invalidatesTags: ['generals']
    }),
    getPromotionsAll: builder.mutation<DataRTKReturnList<IPromotion>, undefined>({
      query: () => ({
        url: `/glemo/promotions/get-all`,
        body: JSON.stringify({
          title: null,
          activated: null
        }),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      }),
      invalidatesTags: ['generals']
    }),
    createCommentBlog: builder.mutation<string, ICommentBlog>({
      query: (obj) => ({
        url: `/glemo/create-comment-blog`,
        body: JSON.stringify(obj),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      }),
      invalidatesTags: ['generals']
    }),
    createCommentResponseBlog: builder.mutation<string, ICommentBlog>({
      query: (obj) => ({
        url: `/glemo/create-response-comment-blog`,
        body: JSON.stringify(obj),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      }),
      invalidatesTags: ['generals']
    }),
    getFairById: builder.query<DataRTKReturn<IFair>, string>({
      query: (id) => `/glemo/get-fair-by-id?fairId=${id}`,
    }),
    getAddressByZipCode: builder.query<DataRTKReturn<IAddressZipcode>, string>({
      query: (cep) => `/addresses/get-full-by-zip-code/${cep}`,
    }),
    getFairByConstructionId: builder.query<DataRTKReturnList<IFair>, string>({
      query: (id) => `/get-all/fair/by-construction-company-id?constructionCompanyId=${id}`,
    }),
    getAllCardsBlog: builder.query<DataRTKReturnList<ICardBlog>, string>({
      query: (idioma) => `/glemo/get-all-blog?idioma=${idioma == 'pt' ? 'pt-br' : idioma}`,
    }),
    getAllCategoriesBlog: builder.query<DataRTKReturnList<ICategoryBlog>, string>({
      query: (idioma) => `/glemo/blog/get-all-categories?idioma=${idioma == 'pt' ? 'pt-br' : idioma}`,
    }),
    getBlogBySlug: builder.query<DataRTKReturn<ICardBlog>, string>({
      query: (slug) => `/glemo/get-blog-by-slug?slug=${slug}`,
    }),
    getBlogDescriptionBySlug: builder.query<DataRTKReturn<string>, string>({
      query: (slug) => `/glemo/glemo/get-blog-description?slug=${slug}`,
    }),
    getNotificationsByUserId: builder.mutation<DataRTKReturnList<INotification>, IReqNotification>({
      query: (obj) => ({
        url: `/glemo/notificaion/get-all-by-user-id`,
        body: JSON.stringify(obj),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      }),
      invalidatesTags: ['generals']
    }),
    toggleNotifications: builder.mutation<string, IToggleNotification>({
      query: (obj) => ({
        url: `/glemo/notificaion/toggle-read-notification`,
        body: JSON.stringify(obj),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      }),
      invalidatesTags: ['generals']
    }),
    getCardsWorkUs: builder.query<DataRTKReturnList<CardWorkUs>, null>({
      query: () => `/glemo/get-all-jobs`,
    }),
    getVagaBySlug: builder.query<DataRTKReturn<CardWorkUs>, string>({
      query: (slug) => `/glemo/get-job-by-slug?slug=${slug}`,
    }),
    candidateVaga: builder.mutation<string, FormCandidate>({
      query: (obj) => ({
        url: `/glemo/create-candidate`,
        body: JSON.stringify(obj),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      }),
      invalidatesTags: ['generals']
    }),
  })
})

export default generalApi
